import type { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import Section from "common/details/grid/section";
import Row from "common/details/grid/row";
import Address from "common/user/address";

type Props = {
  address: ComponentProps<typeof Address>["address"];
};

function SignerAddress({ address }: Props) {
  // HACK: the BE doesn't always send a null address object if it's blank, so we use this hack to test for presence
  if (!address?.line1) {
    return null;
  }
  return (
    <Section>
      <Row
        title={
          <FormattedMessage id="6352b4f7-aefa-4feb-a07d-db7ce4ca4a9e" defaultMessage="Address" />
        }
      >
        <div className="DetailGrid-data--subheading">
          <Address address={address} />
        </div>
      </Row>
    </Section>
  );
}

export default SignerAddress;
